import React from 'react';
// import '../App.scss';
function Card(props) {
      const { url, task, subject, deadline } = props;
      return (
            <div className="card">
                  <div>
                        <a href={url}>
                              <h1>{subject}</h1>
                        </a>
                        <div className="child">
                              <div className="titlebox">
                                    <p className="title">{task}</p>
                              </div>
                              <p className="deadline">{deadline}</p>
                        </div>
                  </div>
            </div>
      );
}
export default Card;
